import { useEffect, useState } from "react";
import styles from "./TradeModel.module.sass";

import classNames from "classnames";
import { useUser } from "../../../../../context";
import Modal from "../../../../../components/Modal";
import Disclaimer from "../../../../../components/Disclaimer";
import TextInput from "../../../../../components/TextInput";
import Loader from "../../../../../components/Loader";
import Card from "../../../../../components/Card";
import { UseDisclosure } from "../../../../../hooks/use-disclosure";
import { UseApi } from "../../../../../hooks/use-api";
import Empthy from "../../../../../components/Empty";
import {
	GetTradeIn,
	GetTradeInBrand,
	PatchTradeInUpdate,
	PostTradeIn,
} from "../../../../../Services/lib/brand";
import Dropdown from "../../../../../components/Dropdown";

const TradeModel = ({ isOpen: isOpen_, onClose: onClose_, item }) => {
	const { locale } = useUser();
	const [{ data, isLoading, error }, getList] = UseApi({
		service: GetTradeIn,
	});

	const { isOpen, onClose, onOpen } = UseDisclosure();

	const close = () => {
		onClose();
		onClose_();
	};

	useEffect(() => {
		getList(item._id);
	}, []);

	return (
		<>
			<Modal
				outSideClickNone
				outerClassName={styles.outer}
				visible={isOpen_}
				onClose={close}
			>
				<Card
					className={styles.card}
					title={"Trade In"}
					classTitle="title-red"
					head={
						<button onClick={onOpen} className="button-small">
							{"Add Trade In"}
						</button>
					}
				>
					{isLoading ? (
						<div className={styles.loaderWrap}>
							<Loader />
						</div>
					) : data ? (
						data?.tradeProducts.length > 0 ? (
							data.tradeProducts.map((e) => {
								return (
									<Row
										getList={() => getList(item._id)}
										key={e._id}
										data={e}
										productID={data._id}
									/>
								);
							})
						) : (
							<Empthy />
						)
					) : (
						<Empthy />
					)}
				</Card>
			</Modal>
			{isOpen && (
				<Modal visible={isOpen} onClose={onClose}>
					<Create
						nftTemplate={item._id}
						onClose={onClose}
						getList={() => getList(item._id)}
						product={data && data?.tradeProducts.length > 0}
						productID={data && data._id}
					/>
				</Modal>
			)}
		</>
	);
};

const Row = ({ data, getList, productID }) => {
	const [{ isLoading: loading }, tradeInBrands] = UseApi({
		service: PatchTradeInUpdate,
		successMsg: "Removed",
	});

	const delete_ = async () => {
		const body = {
			_id: productID,
			type: "remove",
			tradeProducts: [
				{
					tradeTemplate: data.tradeTemplate._id,
					amount: data.amount,
				},
			],
		};

		const res = await tradeInBrands(body);
		if (res) {
			getList();
		}
	};

	const { locale } = useUser();

	return (
		<div className={styles.row}>
			<div className={styles.img}>
				<img src={data.tradeTemplate.image} alt={"_image"} />
			</div>
			<div>{"$ " + data.amount}</div>
			<div>-</div>
			<div>{data.tradeTemplate.name}</div>
			<button
				onClick={delete_}
				className={classNames("button-small button-stroke-red", {
					disabled: loading, /// isLoading,
				})}
			>
				{loading && <Loader />}
				{"remove"}
			</button>
		</div>
	);
};

const Create = ({ nftTemplate, onClose, getList, product, productID }) => {
	const { locale } = useUser();

	const [selectValue, setSelectV] = useState({
		name: "Select template ID",
	});
	const [brands, setBrands] = useState([]);
	const [{ isLoading: loading }, tradeInBrands] = UseApi({
		service: GetTradeInBrand,
	});
	const [{ isLoading: loadingUpdate }, updateTrade] = UseApi({
		service: PatchTradeInUpdate,
	});

	// template post
	const [tradeAmount, setTradeAmount] = useState("");
	const [filter, setFilter] = useState(
		product
			? {
					page: 1,
					limit: 25,
					search: "",
					tradeTemplate: productID,
			  }
			: {
					page: 1,
					limit: 25,
					search: "",
			  }
	);

	const [{ isLoading }, createTradeIn] = UseApi({
		service: PostTradeIn,
		successMsg: "Success",
	});

	const submitHandler = async (e) => {
		e.preventDefault();

		const body = product
			? {
					_id: productID,
					type: "add",
					tradeProducts: [
						{
							tradeTemplate: selectValue.id,
							amount: tradeAmount,
						},
					],
			  }
			: {
					nftTemplate: nftTemplate,
					tradeProducts: [
						{
							tradeTemplate: selectValue.id,
							amount: tradeAmount,
						},
					],
			  };
		const result = product
			? await updateTrade(body)
			: await createTradeIn(body);
		if (result) {
			await onClose();
			getList();
		}
	};

	const getBrands = async () => {
		const res = await tradeInBrands(filter);
		if (res) {
			const list = res.list.map((e, i) => {
				if (e._id !== nftTemplate && e.status === "MINTED")
					return i + 1 + ". " + e.name + " | " + e._id;
			});
			setBrands(list);
		}
	};
	useEffect(
		(e) => {
			getBrands();
		},
		[filter]
	);

	return (
		<Card title={"Add Trade In"} classTitle="title-red">
			<form onSubmit={submitHandler} className={styles.grid}>
				<Dropdown
					value={selectValue.name}
					setValue={(status) => {
						setSelectV({
							name: status.split(" | ")[0],
							id: status.split(" | ")[1],
						});
					}}
					setSearchInput={(val) => {
						setFilter((e) => {
							return {
								...e,
								search: val,
							};
						});
					}}
					options={brands}
				/>
				<TextInput
					placeHolder={"Trade In Amount"}
					required
					type="number"
					onChangeInput={(val) => setTradeAmount(val)}
					label={"Trade In Amount"}
				/>
				<div className={styles.buttonContainer}>
					<button
						className={classNames("button-small", {
							disabled: isLoading || loadingUpdate,
						})}
					>
						{(isLoading || loadingUpdate) && <Loader white />}
						{"Save"}
					</button>
				</div>
			</form>
		</Card>
	);
};

export default TradeModel;
